import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-new-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ReservationNewStore = {
    course: Map<unknown, unknown>;
};

const initialState = (): ReservationNewStore => {
    return {
        course: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ReservationNewStore> = {
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationNewStore>(initialState(), actionsMap);
